import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"

export const appConfig: AppConfig<"trivium"> = {
  appId: "trivium",
  cookiePrefix: "trivium",
  lang: "EN",
  admins: {
    mfaEnabled: true,
    otpExpiration: "10 minutes",
    sessionDuration: "30 days"
  },
  artist: {
    name: "Trivium"
  },
  meta: {
    description: "Trivium"
  },
  emailSender: {
    name: "Trivium",
    email: "trivium@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "00000000-0000-0000-0000-000000000000",
    initialOwnerAddress: "0x853c7B3E122B6Fe96DF2176df04fA3cFd58bAc38"
  },
  tasks: {
    exclusiveLinkDelay: "1 hour"
  },
  checkIn: {
    hidePrompt: true
  },
  shopUrl: "https://store.trivium.org",
  socialLinks: [
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://www.instagram.com/triviumband"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://www.tiktok.com/@triviumband"
    },
    {
      platform: SocialPlatform.Spotify,
      label: "Spotify",
      href: "https://open.spotify.com/artist/278ZYwGhdK6QTzE3MFePnP"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://x.com/TriviumOfficial?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
    },
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://www.facebook.com/groups/Triviumworld"
    },
    {
      platform: SocialPlatform.Website,
      label: "Website",
      href: "https://www.trivium.org"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.png`,
          width: 60
        },
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/logo.png`,
            width: 60
          }
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
